/** @param {import("../viewer-deps.js").ViewerDeps} deps */
export function createStructure(deps) {
  function buildTree(doc) {
    const tree = deps.tree;
    if (!tree) return;
    const scrollTop = tree.scrollTop;
    tree.replaceChildren();

    if (!doc) {
      const hint = document.createElement("p");
      hint.className = "tree-empty-hint";
      hint.textContent = "Контракт не загружен. Выберите источник в шапке или нажмите «Обновить».";
      tree.append(hint);
      return;
    }

    try {
      deps.buildTreeBody(doc);
    } catch (error) {
      console.error("buildTree failed", error);
      deps.errorBox.hidden = false;
      deps.errorBox.textContent = `Structure: ${error.message}`;
      const hint = document.createElement("p");
      hint.className = "tree-empty-hint";
      hint.textContent = "Не удалось построить дерево Structure.";
      tree.append(hint);
      return;
    }

    tree.scrollTop = scrollTop;
    deps.applyDefaultTreeCollapse();
    deps.markTree();
  }

  return { buildTree };
}
